export default __webpack_public_path__ + "static/media/flavorgpi-white.3f2eb853.png";